import './DateRangeFilterForm.css';
import * as React from 'react';
import { t } from 'i18next';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { connect } from 'react-redux';

const DateRangeFilterForm = ({ updateCurrent, current }) => {
  let fromInput;
  let toInput;

  return (
    <div className="DateRangeFilterForm">
      <div>
        <label>
          {t('filters.label.from')}
          :
        </label>
        <input ref={i => fromInput = i}
          defaultValue={moment(current.start_date).format('MM/DD/YY')}
          onChange={(e) => {
            const date = moment(e.target.value, 'MM/DD/YY');
            if (date.isValid()) {
              updateCurrent({
                ...current,
                start_date: date.format('YYYY-MM-DD'),
              });
            }
          }}
        />
        <DatePicker inline
          selected={moment(current.start_date)}
          onSelect={(date) => {
            updateCurrent({
              ...current,
              start_date: date.format('YYYY-MM-DD'),
            });
            fromInput.value = date.format('MM/DD/YY');
          }}
        />
      </div>
      <div>
        <label>
          {t('filters.label.to')}
:
        </label>
        <input ref={i => toInput = i}
          defaultValue={moment(current.end_date).format('MM/DD/YY')}
          onChange={(e) => {
            const date = moment(e.target.value, 'MM/DD/YY');
            if (date.isValid()) {
              updateCurrent({
                ...current,
                end_date: date.format('YYYY-MM-DD'),
              });
            }
          }}
        />
        <DatePicker inline
          selected={moment(current.end_date)}
          onSelect={(date) => {
            updateCurrent({
              ...current,
              end_date: date.format('YYYY-MM-DD'),
            });
            toInput.value = date.format('MM/DD/YY');
          }}
        />
      </div>
    </div>
  );
};

export default connect()(DateRangeFilterForm);
